import { Component, signal } from '@angular/core';
import { AlgorithmFormComponent } from "@app/components/forms/algorithm/form.component";
import { AlgorithmHelperService } from '@app/services/helpers/algorithm-helper.service';
import { Router, RouterModule } from '@angular/router';
import { AppHttpError } from '@app/interfaces/pg-models.interface';
import { AlgorithmCreate } from '@app/models/algorithm.interface';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { HeadMetaComponent } from '@app/components/ui.component';
import { ToastService } from '@app/services/toast.service';
import { HelpButtonComponent } from "@app/components/help-button/help-button.component";

@Component({
    selector: 'app-algorithm-create',
    templateUrl: './create.page.html',
    styleUrl: './create.page.scss',
    imports: [
        HeadMetaComponent,
        AlgorithmFormComponent,
        RouterModule,
        FontAwesomeModule,
        HelpButtonComponent
    ]
})
export class AlgorithmCreatePage {
  public title = 'New Algorithm';
  formValid = signal(false);
  formValue = signal<AlgorithmCreate | null>(null);

  faArrowLeft = faArrowLeft;

  constructor(
    private algorithmService: AlgorithmHelperService,
    private router: Router,
    private toast: ToastService,
  ) {
    
  }

  create() {
    let val = this.formValue();
    if(val) {
      this.algorithmService.create(val)
        .subscribe({
          next: id => {
            console.log(id)
            if(id) {
              this.router.navigateByUrl('/algorithms/' + id);
            }
          },
          error: (err: AppHttpError) => {
            console.log(err.error)
            this.toast.message({ message: err.error.code + ": " + err.error.message, type: 'error'});
          }
        });
    }
  }
}
